module.exports = __webpack_public_path__ + "media/images/folk_logo-cdf50b4c277d7cae7d23c1867a2181fa.png";